import React from "react"

const MenuSection: React.FC = () => {
  const images = Array.from({ length: 38 }, (_, i) => {
    const idx = (i + 1).toString().padStart(2, "0")
    return `/web-ttmi/menu/menu-thu-duc/1-${idx}.jpg`
  })

  return (
    <section className="w-full max-w-2xl mx-auto px-6 sm:px-8 py-12 sm:py-16">
      <div className="grid grid-cols-1 gap-6">
        {images.map(src => (
          <div key={src} className="w-full">
            <img src={src} alt={src} className="w-full h-auto object-cover" />
          </div>
        ))}
      </div>
    </section>
  )
}

export default MenuSection
